import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '@/core/store/hooks'
import { setToast } from '@/core/services/Toast/store/toast.slice'
import { AxiosError } from 'axios'

export interface ErrorsScheme {
  Details?: {
    PropertyName: string | null
  }
  Code: string
  Description: string
  RefId?: string
}

export interface ErrorsObjScheme {
  [key: string]: string
}

const useBackendError = (): [
  setBackendError: (errors: unknown) => void,
  fieldsError?: Record<string, ErrorsObjScheme>,
  resetErrors?: (key?: string) => void,
] => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation('translation')
  const [errors, setErrors] = useState<ErrorsScheme[]>([])
  const [fieldsError, setFieldsError] = useState<
    Record<string, ErrorsObjScheme>
  >({})
  const [error, setError] = useState<ErrorsScheme[]>([])

  const convertArrayToObject = (array: ErrorsScheme[]) => {
    const initialValue = {}

    return array.reduce((obj, item) => {
      const defaultKey = item?.Details?.PropertyName as string
      const str = defaultKey.charAt(0).toLowerCase() + defaultKey.slice(1)
      let key: string = str || ''
      let message = ''

      switch (item.Code) {
        case 'errinput_modelprop_notempty':
          message = 'The field is a required'
          break
        case 'errinput_email_busy':
          {
            message = 'errinput_email_busy'
            key = 'email'
          }
          break

        case 'errinput_discountcode_notfound':
          {
            message = 'errinput_discountcode_notfound'
            key = 'discountCode'
          }
          break
      }

      return {
        // ...obj,
        [key]: { message: t(message) },
      }
    }, initialValue)
  }

  const generateErrorGlobal = (arr: ErrorsScheme[]) => {
    // console.log('generateErrorGlobal', arr)

    const newArr = arr.map(el => {
      switch (true) {
        case el.Code === 'erraction_execution_bad':
          el.Code = el.Description.replace('General Execution error: ', '')
          break
        case el.Code === 'errinput_model_notfound' &&
          el.Details?.PropertyName === 'userId':
          el.Code = el.Description = 'User is not found'
          break
      }
      return el
    })

    return newArr
  }

  const filterError = () => {
    const errorsGlobal: ErrorsScheme[] = []
    const fields: ErrorsScheme[] = []
    // console.log('filterError', error)
    error.forEach(el => {
      if (
        el &&
        el?.Details?.PropertyName &&
        el?.Details?.PropertyName !== 'userId' &&
        el.Code !== 'errinput_licenseversion_alreadyexists' &&
        el.Code !== 'errinput_licenseserial_alreadyexists' &&
        el.Code !== 'errinput_licenseserial_notfound' &&
        el.Code !== 'errinput_companycode_alreadyexists'
      ) {
        fields.push(el)
      } else {
        errorsGlobal.push(el)
      }
    })

    // console.log('errorsGlobal', errorsGlobal)
    // console.log('fields', fields)

    setErrors(generateErrorGlobal(errorsGlobal))
    setFieldsError(convertArrayToObject(fields))
  }

  const setBackendError = (errors: unknown): void => {
    const { response } = errors as AxiosError

    // console.log('setBackendError', response)
    // console.log('setBackendError errors', errors)

    if (response && response.status === 401) {
      setError([
        {
          Description: 'Unknown login or incorrect password',
          Code: 'errauth_loginpass_bad',
        },
      ])
      return
    }

    if (response === undefined) {
      setError([
        {
          Description: 'An unforeseeable mistake has occurred',
          Code: 'error-0',
        },
      ])
      return
    }

    if (response && response.data && Array.isArray(response.data)) {
      setError(response.data)
    } else {
      setError([response.data])
    }
  }

  const resetErrors = (key?: string) => {
    if (key) {
      console.log(key)
    } else {
      setErrors([])
      setFieldsError({})
    }
  }

  useEffect(() => {
    filterError()
  }, [error])

  useEffect(() => {
    if (errors && errors.length > 0) {
      errors.forEach(el => {
        setTimeout(() => {
          dispatch(
            setToast({
              type: 'error',
              message: t(el.Code),
            }),
          )
        }, 0)
      })
    }
  }, [errors])

  return [setBackendError, fieldsError, resetErrors]
}

export default useBackendError
